import axios from './axios'

// TODO cleanup
export default {

    getAllRoles: f => {
        axios.get('/role/all').then(r => {
            console.log(r.data)
            f(r.data)
        }).catch(reason => {
            console.error(reason)
        })
    },

    get(params, callback) {
        axios.get("/roles", { params: params }).then(res => {
            callback(res.data)
        })
    },

    delete: (roleId, f) => {
        axios.post("/role/delete", {
            id: roleId
        }).then(r => f(r.data)).catch(r => console.error(r))
    },

    create: (name, permissions, f) => {
        axios.post('/role/create', {
            name: name,
            permissions: permissions
        }).then(r => f(r.data)).catch(r => console.error(r))
    },

    update: (roleId, newName, permissions, f) => {
        axios.post('/role/update', {
            id: roleId,
            newName: newName,
            permissionchange: true,
            permissions: permissions
        }).then(r => f(r.data)).catch(r => console.error(r))
    },

    delete: (roleId, f) => {
        axios.post("/role/delete", {
            id: roleId
        }).then(r => f(r.data)).catch(r => console.error(r))
    },

    allPermissions: (f) => {
        axios.get("/permissions").then(r => {
            f(r.data)
        })
    }

}